/**
 * Comply brand theme — logos, background images, and colors.
 * Mirrors the shape of theme.deloitte.js so the two are interchangeable.
 */
import sidebarLogoExpanded from "../../../../assets/brands/comply/sidebar-logo-expanded.svg";
import sidebarLogoCollapsed from "../../../../assets/brands/comply/sidebar-logo-collapsed.svg";
import loginBackground from "../../../../assets/brands/comply/login-background.png";
import loginLogo from "../../../../assets/new icons/Comply Extractor 1.png";
import favicon from "./favicon.png";

export const complyTheme = {
  name: "comply",
  title: "Comply Extractor",
  favicon,
  logos: {
    sidebarExpanded: sidebarLogoExpanded,
    sidebarCollapsed: sidebarLogoCollapsed,
    sidebarAlt: "Comply Extractor",
    login: loginLogo,
  },
  images: {
    loginBackground,
  },
  colors: {
    sidebarBackground: "#ffffff",
    sidebarText: "#222222",
    sidebarHoverBackground: "#eaf6fd",
    sidebarActiveBackground: "#eaf6fd",
    sidebarActiveText: "#2aa7e0",
    primary: "#2aa7e0",
    secondary: "#1976d2",
    buttonPrimaryBackground: "#2aa7e0",
    buttonPrimaryText: "#ffffff",
    buttonOutlineBackground: "transparent",
    buttonOutlineText: "#2aa7e0",
    buttonOutlineBorder: "#2aa7e0",
  },
};

export default complyTheme;
